import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';

import UrlFetcherFetch from '../../fetch/urlFetcherFetch';


function EditorUrlFetcherRequest() {

    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const sendRequest = () => {
        UrlFetcherFetch.requestAccess(email).then(response => {
            setMessage("Check your email for a link.")
        }).catch(err => {
            setErrorMessage("Error fetching a link. Make sure you are using an @cbinsights.com email address and try again")
        });
    }

    return (
        <Grid container spacing={2}>
            <Grid size={10} offset={1}>
                <Paper>
                    <div style={{marginTop: "16px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                        <Typography
                            sx={{color: "#777", marginTop: "96px"}}
                            variant={'subtitle1'}
                        >
                            Enter your email address to request a link.
                        </Typography>
                        <TextField
                            sx={{marginTop: "16px", width: "400px"}}
                            id="outlined-basic"
                            label="Email"
                            variant="outlined"
                            value={email}
                            onChange={(event)=> {setEmail(event.target.value)}}
                        />
                        <Button variant="contained"
                                sx={{marginTop: "28px"}}
                                onClick={sendRequest}
                        >
                            Fetch
                        </Button>
                        <Typography
                            sx={{color: "#555", marginTop: "16px", marginBottom: "48px"}}
                            variant={'subtitle1'}
                        >
                            {message}
                        </Typography>
                        <Typography
                            sx={{color: "rgb(211, 47, 47)", marginTop: "16px", marginBottom: "48px"}}
                            variant={'subtitle1'}
                        >
                            {errorMessage}
                        </Typography>
                    </div>
                </Paper>
            </Grid>
        </Grid>
    )
}

export default EditorUrlFetcherRequest;